import { validateForm } from '../utils';
import useUser from '../../../user';
import { getFormValues, getStepFieldValue } from '../utils';
import { useSelector } from 'react-redux';

const useResetPassword = () => {
  const { sendPasswordResetLink } = useUser();
  const user = useSelector(state => state.User);
  const { dataLinks } = useSelector(state => state.DataLinks);

  const issueResetPasswordLink = async ({
    step,
    history,
    documents,
    selections,
    local,
    data,
    params
  }) => {
    let payload = {};
    if (step.formId) {
      if (!validateForm({ formId: step.formId })) {
        return { error: 'invalid form values' };
      }

      payload = getFormValues({ formId: step.formId, returnObject: true });
    }

    step.fields
      ?.filter(f => f.value.toString().indexOf('{data.') === -1)
      .forEach(stepField => {
        const fieldValue = getStepFieldValue({
          stepField,
          underlyingField: {
            type: stepField.fieldType
          },
          selections,
          history,
          documents,
          local,
          user,
          dataLinks,
          data,
          params
        });

        // make sure text fields are no co-erced to numbers if the contain number strings
        if (stepField?.type === 'string' && fieldValue?.toString) {
          payload[stepField.name] = fieldValue.toString();
        } else {
          payload[stepField.name] = fieldValue;
        }
      });

    return await sendPasswordResetLink(payload.email);
  };

  return {
    issueResetPasswordLink
  };
};

export default useResetPassword;
